import { activeTourState } from 'components/onboarding-tour/storage';

const bootOnboardingTour = async () => {
  // The driver chunk is loaded only while a tour is actually in progress.
  if (!activeTourState()) return;

  try {
    const { mountTourForCurrentPage } = await import('components/onboarding-tour/driver');
    await mountTourForCurrentPage();
  } catch {
    // A failed chunk load or a crashed mount must never break the host page.
  }
};

// Keep the shared entry chunk free of top-level await.
void bootOnboardingTour();
